import { render, staticRenderFns } from "./riqingReport.vue?vue&type=template&id=478de5a6"
import script from "./riqingReport.vue?vue&type=script&lang=js"
export * from "./riqingReport.vue?vue&type=script&lang=js"
import style1 from "./riqingReport.vue?vue&type=style&index=1&id=478de5a6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports